import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";
import {RoleDto} from "../../models/role-models";

@Component({
  selector: 'app-delete-role-dialog',
  templateUrl: './delete-role-dialog.component.html',
  styleUrls: ['./delete-role-dialog.component.scss']
})
export class DeleteRoleDialogComponent {

  @Input() item: RoleDto | undefined

  @Output() deleteRole: EventEmitter<number> = new EventEmitter<number>()

  constructor(
    private modalService: ModalService
  ) {
  }

  closeModal() {
    this.modalService.closeModal()
  }

  deleteCurrentRole() {
    this.deleteRole.emit(this.item?.id)
  }

}
